
import { defineComponent } from "vue";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default defineComponent({
  name: "DonationCount",
  components: { Bar },
  props: {
    role: {
      type: String,
      required: true,
    },
    governmentLevel: {
      type: String,
      required: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      governmentLevels: ["Barangay", "Municipality", "City"] as string[],
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      const canvas = document.getElementById(
        "donationsPerLocation"
      ) as HTMLCanvasElement;
      const windowWidth = window.innerWidth;

      let canvasWidth = 600;
      if (windowWidth < 576) {
        canvasWidth = 540;
      } else if (windowWidth >= 576 && windowWidth < 768) {
        canvasWidth = 624;
      } else if (windowWidth >= 768 && windowWidth <= 1200) {
        canvasWidth = 864;
      } else if (windowWidth > 1200 && windowWidth < 1400) {
        canvasWidth = 600;
      }
      canvas.style.width = canvasWidth.toString() + "px";
      canvas.style.height = (canvasWidth / 2).toString() + "px";
    });
  },
  computed: {
    chartOptions() {
      return {
        responsive: true,
        scales: {
          x: {
            grid: {
              color: this.role === "Administrator" ? "#56f576" : "#e5e5e5",
            },
            ticks: {
              color: this.role === "Administrator" ? "#ffffff" : "#666666",
            },
          },
          y: {
            grid: {
              color: this.role === "Administrator" ? "#56f576" : "#e5e5e5",
            },
            ticks: {
              color: this.role === "Administrator" ? "#ffffff" : "#666666",
            },
          },
        },
        plugins: {
          legend: {
            labels: {
              color: this.role === "Administrator" ? "#ffffff" : "#666666",
            },
          },
        },
      };
    },
  },
});
